export const NAME_LENGTH = 40
export const SHORT_DESCRIPTION_LENGTH = 30
export const DESCRIPTION_LENGTH = 9999
export const EXTRA_DESCRIPTION_LENGTH = 100

export const UNLIMITED_AVAILABILITY_THRESHOLD = 9999
export const STARTING_YEAR = 2026
export const FIRST_CULTIVATION_PLAN_YEAR = 2026
